<div class="flex gap-(--gap-loose) flex-col">
  @if (measure(); as currentMeasure) {
    <ces-button-secondary
      [hasPermission]="{ method: 'putMeasureDetailResource', assetId: currentMeasure.assetId }"
      [label]="'common.buttons.edit' | transloco"
      size="small"
      icon="edit"
      (onClick)="editMeasure()" />

    <ces-property [label]="'common.labels.name' | transloco">{{ currentMeasure.name }}</ces-property>

    @if (kind() !== 'analysis-post') {
      <ces-property [label]="'common.labels.type' | transloco">
        @if (measureType(); as currentMeasureType) {
          {{ currentMeasureType.name }}
        } @else {
          {{ currentMeasure.measureTypeId }}
        }
      </ces-property>
    }

    <ces-property [label]="'common.labels.unit' | transloco">
      @if (unit(); as currentUnit) {
        {{ formatUnitLabel(currentUnit.name, currentUnit.symbol) }}
      } @else {
        {{ currentMeasure.unitId }}
      }
    </ces-property>

    <ces-property [label]="'common.labels.locations' | transloco" [chips]="locations()" />

    @if (kind() === 'manual') {
      <ces-property [label]="'entities.measure.fields.barcode' | transloco">{{ currentMeasure.barcode }}</ces-property>
    }
    <ces-property [label]="'common.labels.description' | transloco">{{ currentMeasure.description || 'N/A' }}</ces-property>
    @if (kind() === 'manual') {
      <ces-property [label]="'common.labels.mandatory' | transloco" type="boolean" [booleanValue]="currentMeasure.priority || false" />
    }

    @if (kind() === 'automatic') {
      @if (automaticMeasure(); as currentAutomatic) {
        <div class="flex flex-row gap-(--gap-loose)">
          <ces-property
            [label]="'entities.measure.fields.frequency' | transloco"
            type="frequency"
            [value]="currentAutomatic.frequency" />
          @if (currentAutomatic.hour) {
            <ces-property [label]="'entities.measure.fields.hour' | transloco">{{ currentAutomatic.hour }}</ces-property>
          }
        </div>
        @if (currentAutomatic.dayOfWeek !== null || currentAutomatic.dayOfMonth !== null || currentAutomatic.month !== null) {
          <div class="flex flex-row gap-(--gap-loose) flex-wrap">
            @if (currentAutomatic.dayOfWeek !== null && currentAutomatic.dayOfWeek !== undefined) {
              <ces-property [label]="'entities.automaticMeasure.fields.dayOfWeek' | transloco">{{
                'common.weekdays.' + dayOfWeekKey(currentAutomatic.dayOfWeek) | transloco
              }}</ces-property>
            }
            @if (currentAutomatic.dayOfMonth !== null && currentAutomatic.dayOfMonth !== undefined) {
              <ces-property [label]="'entities.automaticMeasure.fields.dayOfMonth' | transloco">{{
                currentAutomatic.dayOfMonth
              }}</ces-property>
            }
            @if (currentAutomatic.month !== null && currentAutomatic.month !== undefined) {
              <ces-property [label]="'entities.automaticMeasure.fields.month' | transloco">{{
                'common.months.' + currentAutomatic.month | transloco
              }}</ces-property>
            }
          </div>
        }
        <ces-property [label]="'entities.measure.fields.timeserie' | transloco">{{
          currentAutomatic.externalId || 'N/A'
        }}</ces-property>
        <ces-property
          [label]="'entities.automaticMeasure.fields.overwrite' | transloco"
          type="boolean"
          [booleanValue]="currentAutomatic.overwrite || false"
          [tooltip]="'entities.automaticMeasure.tooltips.overwrite' | transloco" />
      }
    }
  } @else {
    {{ 'entities.measure.messages.notFound' | transloco }}
  }
</div>
